import React from 'react'
import '../static/style/aside.css'
import CloseIcon from '@mui/icons-material/Close';
import {motion} from 'framer-motion'
import cv from '../files/cv__bekkar__merwan.pdf'

function Asidebar(props) {
  return (
    <div className='asideContainer' onClick={()=>{props.setOpenaside(false)}}>
        <motion.div  animate={{width:350}} transition={{duration:0.1, delay:0}} className='aside' onClick={(e)=> e.stopPropagation()}>
            <CloseIcon className='close' onClick={()=>{props.setOpenaside(false)}} />
            <div className='liens'>
                <a href='#'>About</a>
                <a href='#'>Work</a>
                <a href='#'>Skills</a>
                <a href='#'>Contact</a>
                <a href={cv} target="_blank" type="application/pdf"><button>Resume</button></a>
            </div>
        </motion.div>
    </div>
  )
}

export default Asidebar